import { createFileRoute } from '@tanstack/react-router';
import { DpaPage } from '../../pages/DpaPage';
import { staticPageHead } from '../../lib/seo/staticPageHead';

export const Route = createFileRoute('/_site/dpa')({
  head: () =>
    staticPageHead({
      path: '/dpa',
      title: 'Data Processing Addendum - AnyAPI',
      description:
        'The AnyAPI data processing addendum: roles, security measures, sub-processors, retention windows, and transfer terms for the EEA, UK, Switzerland, and Thailand.',
      crumb: 'Data Processing Addendum',
    }),
  component: DpaPage,
});
